import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersSTEMClassesPlanned = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="STEM classes planned" />
    </Box>
  );
};
